import BottomSection from './bottom-section';

export default BottomSection;
